import React, { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import { reset, selectMeteorologyAgroCultureIndexAreaMaps } from 'redux/reducers/meteorologyAgroCultureIndexAreaReducer';
import { CultureIndexAreaMap } from 'types/Meteorology/Agro/CultureIndex/Area/map';
import Button from 'components/DesignSystem/Button';
import useMapDownload from 'hooks/Meteorology/Agro/CultureIndex/Area/useMapDownload';
import useMapData from 'hooks/Meteorology/Agro/CultureIndex/Area/useMapData';
import { cultureIndexAreaApi } from 'services/api/Meteorology/Agro/CultureIndex/Area';
import MapControlPanel from './Map';

export default function CultureIndexAreaControlPanel() {
  const maps: CultureIndexAreaMap[] = useSelector(selectMeteorologyAgroCultureIndexAreaMaps);
  const { setMapFilename } = useMapDownload();
  const { triggerMapDataRequest } = useMapData();

  const makeRequestDisabled = useMemo(() => (
    maps.some((map) => (
      [map.params.culture, map.params.forecastDate, map.params.periodStart, map.params.periodEnd]
        .some((value) => value === undefined)
    ))
  ), [maps]);

  const handleRealizeConsulta = useCallback(async () => {
    // Atualiza o filename e dispara a requisição de dados para todos os mapas ativos
    // Processa todos os mapas em paralelo para melhor performance
    await Promise.all(maps.map(async (map) => {
      setMapFilename(map);
      await triggerMapDataRequest(map);
    }));
  }, [maps, setMapFilename, triggerMapDataRequest]);

  const clearSelection = useCallback(() => {
    // Limpa os filtros selecionados e restaura estado inicial completo
    store.dispatch(reset());
    // Limpa o cache dos mapas do RTK Query
    store.dispatch(cultureIndexAreaApi.util.resetApiState());
  }, []);

  return (
    <div>
      {maps.map((map, index) => (
        <MapControlPanel key={map.id} map={map} position={index + 1} totalMaps={maps.length} />
      ))}
      <Button
        className="w-100 mt-5"
        disabled={makeRequestDisabled}
        onClick={handleRealizeConsulta}
      >
        Realizar consulta
      </Button>
      <Button
        className="w-100 mt-1"
        type="secondary"
        onClick={clearSelection}
      >
        Limpar filtros
      </Button>
    </div>
  );
}
